/**
 * Dependencies.
 */
import { BaseModel, endpoint, prop } from '@prz-dp/services';

/**
 * Interface `IConfigDay`.
 */
interface IConfigDay {
  afternoonEndTime: string;
  afternoonStartTime: string;
  isActive: boolean;
  morningEndTime: string;
  morningStartTime: string;
}

/**
 * Model `ServicePointModel`.
 */
@endpoint('servicePoint')
export default class ServicePointModel extends BaseModel {
  /**
   * Properties.
   */
  @prop()
  id: number;

  @prop()
  city: string;

  @prop()
  code: string;

  @prop()
  configs?: {
    ServicePointAcceptCollects?: string;
    ServicePointAcceptIce?: string;
  };

  @prop()
  countryCode?: string;

  @prop()
  countryName: string;

  @prop()
  dockingDays?: {
    1?: IConfigDay;
    2?: IConfigDay;
    3?: IConfigDay;
    4?: IConfigDay;
    5?: IConfigDay;
    6?: IConfigDay;
    7?: IConfigDay;
  };

  @prop()
  doorNumber: string;

  @prop({ transient: true })
  hasDockingDay: boolean;

  @prop({ transient: true })
  hasPackageCapacity: boolean;

  @prop({ transient: true })
  hasRadiusDistance: boolean;

  @prop({ transient: true })
  hasWorkingDay: boolean;

  @prop()
  latitude: number;

  @prop()
  longitude: number;

  @prop()
  name: string;

  @prop()
  street: string;

  @prop()
  workDays?: {
    1?: IConfigDay;
    2?: IConfigDay;
    3?: IConfigDay;
    4?: IConfigDay;
    5?: IConfigDay;
    6?: IConfigDay;
    7?: IConfigDay;
  };

  @prop()
  zipCode: string;

  /**
   * Constructor.
   */
  constructor(data: Partial<ServicePointModel>) {
    super(data);
  }
}
